import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  showIcon?: boolean;
}
export function CTAButton({
  text = 'Accedé hoy a Irreconocible en 30 Días',
  className = '',
  showIcon = true
}: CTAButtonProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Irreconocible en 30 Días',
        content_type: 'product',
        value: 16999,
        currency: 'ARS'
      });
    }
  };
  return <motion.a href="https://www.mareaa.online/cart/add?id=53167308734829&quantity=1" onClick={handleClick} className={`
        inline-flex items-center justify-center gap-2 
        bg-cta hover:bg-cta-hover text-white 
        font-bold text-lg md:text-xl 
        py-4 px-8 rounded-full 
        shadow-[0_8px_20px_rgba(196,112,78,0.3)]
        transition-colors duration-300
        ${className}
      `} whileHover={{
    scale: 1.03,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} data-id="element-58">
      <span data-id="element-59">{text}</span>
      {showIcon && <ArrowRight className="w-5 h-5" data-id="element-60" />}
    </motion.a>;
}